import React, { useState } from 'react';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import Layout from './layout';
import ProductImage from './product-image';
import ProductImageThumb from './product-thumb-image';
import YoutubeEmbed from './youtube-embed';

// Import Swiper styles
import 'swiper/swiper.min.css';
import 'swiper/modules/free-mode/free-mode.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/thumbs/thumbs.min.css';
import './product-page.css';

function Carousel({ images }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <div className="carousel-container">
      <Swiper
        navigation
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        style={{ marginBottom: '1rem' }}
      >
        {images.map(({ src, alt, youtubeId }) => {
          if (youtubeId != null) {
            return (
              <SwiperSlide key={youtubeId}>
                <YoutubeEmbed embedId={youtubeId} />
              </SwiperSlide>
            );
          }
          return (
            <SwiperSlide key={src}>
              <div
                style={{
                  width: '100%',
                  textAlign: 'center',
                }}
              >
                <ProductImage src={src} alt={alt} objectFit="scale-down" />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        slidesPerView={8}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {images.map(({ src, alt }) => (
          <SwiperSlide key={src}>
            <div
              style={{
                width: '100%',
                textAlign: 'center',
              }}
            >
              <ProductImageThumb
                src={src}
                alt={alt}
                style={{ marginRight: '0.5rem' }}
                objectFit="scale-down"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

function Section({ title, content, id, className }) {
  return (
    <section id={id} className={className}>
      <h2>{title}</h2>
      <div>{content}</div>
    </section>
  );
}

export default function ProductLayout({
  title,
  images,
  sections,
  className,
  demoLink,
}) {
  return (
    <Layout subtitle={title} className={className}>
      <h1>{title}</h1>
      <nav className="page_nav">
        <ul>
          {sections.map(({ title, id }) => (
            <li key={id}>
              <a href={`#${id}`}>{title}</a>
            </li>
          ))}
          {demoLink ? (
            <li>
              <a href={demoLink}>Demo</a>
            </li>
          ) : null}
        </ul>
      </nav>
      <Carousel images={images} />
      {sections.map((section) => (
        <React.Fragment key={section.title}>
          <hr />
          <Section {...section} />
        </React.Fragment>
      ))}
    </Layout>
  );
}
